/* eslint-disable import/prefer-default-export */
import React from 'react';
import RehypeReact from 'rehype-react';
import WowheadTooltip from '../components/WowheadTooltip';

export const renderAst = new RehypeReact({
  createElement: React.createElement,
  components: { 'wowhead-tooltip': WowheadTooltip },
}).Compiler;
